import {
  Avatar,
  Box,
  Divider,
  ListItemIcon,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import { Logout } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { enqueueSnackbar } from "notistack";
import { VpnKey } from "@mui/icons-material";
// import { useAdminContext } from "../../hooks/AdminContext";
import PersonIcon from "@mui/icons-material/Person";
import ChangePassword from "./ChangePassword";
import CustomConfirmation from "../confirmation/CustomConfirmation";
import accountLogo from "../../../assets/images/new_user.jpg";
import { useAdminContext } from "../../../hooks/AdminContext";

export default function Accountmenu({ anchorEl, open, handleClose }) {
  const { pathname } = useLocation();
  //   const { userInfo } = useAdminContext();
  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);
  const [openPasswordModal, setopenPasswordModal] = useState(false);
  const { userInfo } = useAdminContext();
  console.log(userInfo, "userInfouserInfouserInfo");

  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.clear();
    setLogoutDialogOpen(false);
    localStorage.removeItem("user");
    navigate("/");
    enqueueSnackbar("Logout successfully.", { variant: "success" });
  };

  const handleProfile = () => {
    navigate(`/profile-settings`);
    handleClose();
  };
  console.log(userInfo, "useraoshcoai");
  return (
    <>
      <ChangePassword
        openPasswordModal={openPasswordModal}
        setopenPasswordModal={setopenPasswordModal}
      />

      <CustomConfirmation
        open={logoutDialogOpen}
        setOpen={setLogoutDialogOpen}
        title={"Are you sure you want to sign out?"}
        handleAgree={handleLogout}
      />

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            mt: 1.5,
            borderRadius: "10px",
            minWidth: "220px",
            "&::before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
      >
        <MenuItem>
          <Avatar sx={{ mr: 1 }} />
          <Box>
            <Typography variant="body1" sx={{ fontWeight: "bold" }}>
              {userInfo?.first_name} {userInfo?.last_name}
            </Typography>

            <Typography variant="body2" sx={{ fontSize: "12px", opacity: 0.8 }}>
              {userInfo?.email}
            </Typography>
          </Box>
        </MenuItem>
        <Divider />
        {/* <MenuItem onClick={handleProfile}>
          <ListItemIcon>
            <PersonIcon fontSize="small" style={{ color: "#181921" }} />
          </ListItemIcon>
          Edit Profile
        </MenuItem>{" "} */}
        <MenuItem
          onClick={() => {
            handleClose();
            setopenPasswordModal(true);
          }}
        >
          <ListItemIcon>
            <VpnKey fontSize="small" style={{ color: "#181921" }} />
          </ListItemIcon>
          Change Password
        </MenuItem>
        <Divider />
        <MenuItem
          sx={{ color: "#000" }}
          onClick={() => {
            handleClose();
            setLogoutDialogOpen(true);
          }}
        >
          <ListItemIcon>
            <Logout fontSize="small" sx={{ color: "#181921" }} />
          </ListItemIcon>
          Sign Out
        </MenuItem>
      </Menu>
    </>
  );
}
